import { z } from "zod";

export const PluginOAuthRequestSchema = z.object({
  id: z.string(),
  codeChallenge: z.string(),
  readKey: z.string(),
  writeKey: z.string(),
  readKeyConsumed: z.boolean(),
  writeKeyConsumed: z.boolean(),
  oAuthCode: z.string().optional(),
  createdAt: z.coerce.date(),
});

export type PluginOAuthRequest = z.infer<typeof PluginOAuthRequestSchema>;
